import React from 'react';

const Swatch = ({ name, value }) => (
  <div className="card-soft p-5">
    <div className="h-24 rounded-lg" style={{ background: value }}></div>
    <div className="mt-4 flex items-center justify-between">
      <span className="text-[13px] font-medium">{name}</span>
      <span className="text-[12px]" style={{ color: 'var(--fg-dim)' }}>{value}</span>
    </div>
  </div>
);

const StyleGuide = () => {
  return (
    <div className="px-6 md:px-24 pt-24 pb-32">
      <div className="max-w-[1400px] mx-auto">
        <span className="section-tag">Design system</span>
        <h1 className="display-h mt-8 text-5xl md:text-7xl">style guide</h1>

        <h2 className="display-h text-2xl mt-16">Colors</h2>
        <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-5">
          <Swatch name="Background" value="#3D3A4B"/>
          <Swatch name="Surface" value="#34323F"/>
          <Swatch name="Accent" value="#5EEAD4"/>
          <Swatch name="Foreground" value="#E8E6F0"/>
        </div>

        <h2 className="display-h text-2xl mt-20">Typography</h2>
        <div className="mt-6 space-y-6">
          <div className="display-h text-7xl">Display – Poppins</div>
          <div className="text-xl">Body – Inter, calm and readable.</div>
          <div className="text-[13px] uppercase tracking-[0.28em]">Eyebrow – Inter caps</div>
        </div>

        <h2 className="display-h text-2xl mt-20">Buttons</h2>
        <div className="mt-6 flex gap-4 flex-wrap">
          <button className="btn-ghost">Ghost button</button>
          <button className="btn-ghost" style={{ borderColor: 'var(--accent)', color: 'var(--accent)' }}>Accent ghost</button>
        </div>
      </div>
    </div>
  );
};

export default StyleGuide;
